module.exports = __webpack_public_path__ + "static/media/100.506bc823.jpg";